import { useQuery } from '@tanstack/react-query';
import { fetchRecipes } from '../api/recipes';
import { Recipe } from '../types/recipes';

export function useRecipes() {
  return useQuery<Recipe[]>({
    queryKey: ['recipes'],
    queryFn: async () => {
      const response = await fetchRecipes();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}



